import { Page, PageSection, useTrackingClient } from 'src/context/tracking';
import { useGetCurrentPage } from 'src/hooks/useGetCurrentPage';

export function useTracking() {
  const currentPage = useGetCurrentPage();
  const props = { currentPage };
  const client = useTrackingClient();

  function trackDocumentsPageView() {
    client.trackView({
      ...props,
      view: Page.DOCUMENT_PAGE,
      currentPageSection: PageSection.DOCUMENTS,
      eventName: 'apply_documents_displayed',
    });
  }

  function trackDontIncludeResume() {
    client.trackLink({
      ...props,
      link: 'resume_not_included_pressed',
      eventName: 'resume_not_included_pressed',
      currentPageSection: PageSection.RESUME,
      resumeSelectedType: 'do_not_include',
    });
  }

  function trackDontIncludeCoverletter() {
    client.trackLink({
      ...props,
      link: 'cover_letter_not_included_pressed',
      eventName: 'cover_letter_not_included_pressed',
      currentPageSection: PageSection.COVER_LETTER,
    });
  }

  function trackDontIncludeSelectionCriteria() {
    client.trackLink({
      ...props,
      link: 'selection_criteria_not_included_pressed',
      eventName: 'selection_criteria_not_included_pressed',
      currentPageSection: PageSection.SELECTION_CRITERIA,
    });
  }

  return {
    trackDocumentsPageView,
    trackDontIncludeResume,
    trackDontIncludeCoverletter,
    trackDontIncludeSelectionCriteria,
  };
}
